import { render, staticRenderFns } from "./ClassesList.vue?vue&type=template&id=40a844f8"
import script from "./ClassesList.vue?vue&type=script&lang=js"
export * from "./ClassesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports